import { useEffect } from "react";

const useMetaTitle = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  defaultTitle = "CodingPal.org",
}) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    const setMetaTag = (name, content, property = false) => {
      if (!content) return;
      let meta = document.querySelector(
        property ? `meta[property="${name}"]` : `meta[name="${name}"]`
      );
      if (!meta) {
        meta = document.createElement("meta");
        if (property) {
          meta.setAttribute("property", name);
        } else {
          meta.setAttribute("name", name);
        }
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    setMetaTag("description", description);
    setMetaTag("keywords", keywords);
    setMetaTag("og:title", ogTitle || title, true);
    setMetaTag("og:description", ogDescription || description, true);
    setMetaTag("og:image", ogImage, true);
    setMetaTag("og:url", ogUrl || window.location.href, true);

    return () => {
      document.title = defaultTitle;
      const resetMetaTag = (name, defaultContent = "", property = false) => {
        const meta = document.querySelector(
          property ? `meta[property="${name}"]` : `meta[name="${name}"]`
        );
        if (meta) {
          if (defaultContent) {
            meta.setAttribute("content", defaultContent);
          } else {
            meta.remove();
          }
        }
      };

      resetMetaTag("description");
      resetMetaTag("keywords");
      resetMetaTag("og:title", "", true);
      resetMetaTag("og:description", "", true);
      resetMetaTag("og:image", "", true);
      resetMetaTag("og:url", "", true);
    };
  }, [
    title,
    description,
    keywords,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    defaultTitle,
  ]);
};

export default useMetaTitle;
